/**
 * Заголовок состояния проверки — один на значок, экранный разбор и печать.
 *
 * Три состояния, а не два: после #752 нарекание к прозе не закрывает гейт, и
 * анализ бывает `verified` С замечаниями — называть это «не прошёл проверку»
 * было бы неправдой о гейте.
 *
 * Функция принимает `t`, а не возвращает ключ, по двум причинам. Ветвление
 * живёт в одном месте: до этого копий было три (значок, разбор, печать), и
 * четвёртое состояние расходилось бы по ним поодиночке. И `check:i18n-resolution`
 * видит ТОЛЬКО литеральные вызовы `t('…')` — вариант с возвратом ключа увёл бы
 * `reviewRequired` и `unavailable` из-под гейта, то есть опечатка в ключе
 * перестала бы ловиться.
 *
 * Сигнатура `t` сужена до общей части i18next и печатного `TFn`
 * (`lib/print-report/types.ts`): ключ плюс строка запасного текста.
 */

import type { AnalysisVerificationState } from '@aica/api-types/schemas';

type TitleFn = (key: string, fallback: string) => string;

/**
 * Id блока с разбором. Значок объявляет его в `aria-controls`, блок несёт в
 * `id`: без этой пары читалка сообщает «развёрнуто» и не даёт способа дойти до
 * раскрытого содержимого — оно лежит двумя соседями дальше по дереву.
 */
export const VERIFICATION_DETAIL_ID = 'verification-notice-detail';

/** Гейт закрыт. При открытом ничего не удерживали — и говорить так нельзя. */
export function isVerificationWithheld(
  status: AnalysisVerificationState['verificationStatus']
): boolean {
  return status !== 'verified';
}

export function verificationTitle(
  status: AnalysisVerificationState['verificationStatus'],
  t: TitleFn
): string {
  if (status === 'unavailable') {
    return t(
      'records.verificationNotice.unavailable',
      'Automatic verification could not be completed'
    );
  }
  if (status === 'review_required') {
    return t(
      'records.verificationNotice.reviewRequired',
      'This analysis did not clear automatic verification'
    );
  }
  return t(
    'records.verificationNotice.objectionsOnly',
    'Some statements were questioned'
  );
}
